import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const MediaIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M20 3.25H10C8.4834 3.25 7.25 4.4834 7.25 6V6.25H6.5C5.2593 6.25 4.25 7.2593 4.25 8.5V9.25H3C2.0352 9.25 1.25 10.0352 1.25 11V19C1.25 19.9648 2.0352 20.75 3 20.75H15C15.9648 20.75 16.75 19.9648 16.75 19V17.75H17.5C18.7402 17.75 19.75 16.7402 19.75 15.5V14.75H20C21.5166 14.75 22.75 13.5166 22.75 12V6C22.75 4.4834 21.5166 3.25 20 3.25ZM15.25 19C15.25 19.1377 15.1377 19.25 15 19.25H3C2.8623 19.25 2.75 19.1377 2.75 19V11C2.75 10.8623 2.8623 10.75 3 10.75H15C15.1377 10.75 15.25 10.8623 15.25 11V19ZM18.25 15.5C18.25 15.9131 17.9131 16.25 17.5 16.25H16.75V11C16.75 10.0352 15.9648 9.25 15 9.25H5.75V8.5C5.75 8.0864 6.0864 7.75 6.5 7.75H17.5C17.9131 7.75 18.25 8.0864 18.25 8.5V15.5ZM21.25 12C21.25 12.6895 20.6895 13.25 20 13.25H19.75V8.5C19.75 7.2593 18.7402 6.25 17.5 6.25H8.75V6C8.75 5.3105 9.3105 4.75 10 4.75H20C20.6895 4.75 21.25 5.3105 21.25 6V12Z"
        fill={color}
      />
      <path
        d="M12.2319 14.4199L7.2319 12.4199C7.0405 12.3423 6.8213 12.3662 6.6494 12.4824C6.478 12.5986 6.375 12.7925 6.375 13V17C6.375 17.207 6.478 17.4014 6.6494 17.5176C6.7544 17.5889 6.8769 17.625 7 17.625C7.0786 17.625 7.1572 17.6104 7.2319 17.5801L12.2319 15.5801C12.4692 15.4854 12.625 15.2559 12.625 15C12.625 14.7441 12.4692 14.5146 12.2319 14.4199ZM7.625 16.0771V13.9228L10.3169 14.9999L7.625 16.0771Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

MediaIcon.displayName = 'MediaIcon';
